const MENSAGEM_100 =
  'Parabéns! Agora é com a gente: seu certificado será emitido em até 90 dias.'

export const obterMensagemProgresso = (percentual: number): string | null => {
  if (percentual >= 100) {
    return MENSAGEM_100
  }

  if (percentual >= 90) {
    return 'Quase lá. Falta pouco para o seu certificado.'
  }

  if (percentual >= 75) {
    return 'Reta final! Se ainda não enviou seus documentos, este é o momento.'
  }

  if (percentual >= 50) {
    return 'Falta só metade para você conquistar seu certificado.'
  }

  if (percentual >= 25) {
    return 'Um quarto do caminho já foi. Continue assim!'
  }

  return null
}
